const text = `MENZIONI LEGALI SULL'APPLICAZIONE SIDE ONCO SKIN ®


EDITORE


PIERRE FABRE DERMO-COSMETIQUE, società per azioni semplificata con sede sociale al seguente indirizzo: Les Cauquillous - 81500 Lavaur - Francia, registrata nel R.C.S. di Castres con il numero 319 137 576.

FINANZIAMENTO

PIERRE FABRE DERMO-COSMETIQUE, società per azioni semplificata con sede sociale al seguente indirizzo: Les Cauquillous - 81500 Lavaur - Francia, registrata nel R.C.S. di Castres con il numero 319 137 576.



Direttore della pubblicazione


Frédéric Ennabli, Presidente di Pierre Fabre Dermo-Cosmétique


Webmaster


contact.avene@pierre-fabre.com


Host


SOCIETE OVH

SAS con capitale di 10.069.020 euro, registrata al 2 di rue Kellermann - 59100 Roubaix - Francia,

con il numero 537 407 926 e con sede sociale al 2 di rue Kellermann - 59100 Roubaix - Francia


Crediti


Redazione/Foto: Professoressa Caroline ROBERT, Dottoressa Emmanuelle VIGARIOS, Professor Vincent SIBAUD, Professor Jean-Pierre DELORD,

Progettazione/realizzazione tecnica:

Agence Henri Trip - 756 CHEMIN DE LA CRABO 31870 LAGARDELLE-SUR-LEZE (Francia) - SIRET n°: 88821442600015



CONDIZIONI GENERALI DI UTILIZZO DELL'APP SIDE ONCO SKIN ®

Le presenti condizioni generali di utilizzo (di seguito le "CGU") determinano le condizioni di accesso e d’uso dell'app per smartphone "ONCO SKIN®" di proprietà esclusiva (di seguito l'"App"), che gli utenti (di seguito gli "Utenti") accettano anche solo consultandole. L'App può essere scaricata da: Apple Store, Google Play. Nel caso in cui non si intenda accettare le presenti CGU, non sarà possibile utilizzare l’App. Le CGU sono assoggettate alla legge francese e possono essere modificate in qualsiasi momento senza preavviso. L'uso e la consultazione dell'App sono limitati a scopi personali e non commerciali. In generale, l'Utente si astiene dall'utilizzare tutta l’App o parte di essa per scopi illeciti (diritti d'autore) o contrari alle presenti CGU. Consultando l’App, l'Utente accetta di rispettare le presenti CGU così come visualizzate alla data di consultazione.


ARTICOLO 1. OGGETTO DELL’APP:


L'App è stata creata per supportare e formare i professionisti della sanità (medici di base e specialisti, farmacisti, personale paramedico, medici specializzandi) nella presa in carico di pazienti affetti da sintomi dermatologici legati ai trattamenti antitumorali, grazie:

• alla digitalizzazione del libro "Dermatologie des traitements anticancéreux" della Professoressa Caroline ROBERT e del Dottor Vincent SIBAUD;

• a quiz e casi di studio per i professionisti della sanità.

(di seguito le "Informazioni").

L'App non costituisce un'offerta contrattuale. L'App è gratuita e non prevede acquisti integrati.

In particolare, l'App diffonde Informazioni non contrattuali sulle patologie dermatologiche, con il costante obiettivo di migliorare la cura dei pazienti da parte dei suddetti professionisti della sanità, ma senza alcuna intenzione di offrire direttamente l'acquisto di un prodotto o servizio (salvo espressa indicazione contraria) relativo a tali patologie.

Poiché l'aggiornamento dell’App avviene tenendo conto di tutte le attività, potrebbe accadere che alcune nuove Informazioni o annunci non siano più validi al momento della loro diffusione o che siano semplicemente superati. PFDC non può garantire, nonostante gli sforzi attuati, che tutte le Informazioni o le notizie pubblicate sull'App siano completamente aggiornate.

Le Informazioni fornite nell'App sono destinate a migliorare, e non a sostituire, il rapporto esistente tra professionista della sanità e paziente.


ARTICOLO 2. POLITICA EDITORIALE:


Il contenuto scientifico dell'App è in parte redatto da medici esperti nel proprio campo dermatologico:

•

• Professor Vincent SIBAUD


Il contenuto dell'App viene aggiornato ogni tre (3) mesi.


ARTICOLO 3. SPECIFICHE DEI REQUISITI DI CONFIGURAZIONE


Pierre Fabre Dermo-Cosmétiques (PFDC) ricorda agli Utenti che l'utilizzo dell'App presuppone che si disponga delle competenze hardware e software necessarie ai fini dell’uso di Internet. Per utilizzare l'App tramite telefono cellulare (di seguito il "Dispositivo"), l'Utente deve disporre di adeguato accesso a Internet a banda larga, di un abbonamento telefonico che consenta l'accesso a Internet e di un telefono cellulare compatibile con l'App stessa: smartphone (IOS, Android), connessione wap, wifi e/o connessione 3G/4G.


ARTICOLO 4. CREAZIONE E CANCELLAZIONE DI UN ACCOUNT UTENTE


Per ottenere l'accesso all'App, è necessario registrarsi e creare un account utente (di seguito l’"Account utente"). Gli utenti sono, quindi, invitati a scaricare l'App e a compilare il modulo di registrazione (professione, dati di contatto, indirizzo e-mail e password). Ogni Utente è autorizzato ad avere un solo (1) Account Utente. Sul Dispositivo dell'Utente può essere installata una sola (1) App.


L'Utente riconosce la propria responsabilità relativamente al rispetto della privacy e al carattere personale di ID e password associati al proprio Account Utente. A tal fine, l’Utente accetta la personale ed esclusiva responsabilità nei confronti di PFDC relativamente a tutte le attività effettuate tramite il proprio Account Utente, nonché alla protezione della propria password. La password dell'Utente deve essere conservata in modo sicuro e non deve essere comunicata né condivisa con terzi. Pertanto, qualunque connessione o trasmissione di dati effettuata con la password di un Utente sarà considerata come effettuata da quest’ultimo. PFDC non può in alcun caso essere ritenuta responsabile dello smarrimento di tale password. In caso di smarrimento, furto o usurpazione della password e/o dell’Account Utente, l’Utente stesso si impegna a informare tempestivamente PFDC all’indirizzo che figura nell’intestazione delle presenti CGU o tramite posta elettronica al seguente indirizzo: contact.avene@pierre-fabre.com.


L’Utente può richiedere in qualsiasi momento la cancellazione del proprio Account Utente e dei dati che lo riguardano, senza dover fornire alcuna ragione, semplicemente inviando una e-mail all’indirizzo contact-avene@pierre-fabre.com, oppure tramite posta all’indirizzo che figura nell’intestazione delle presenti CGU.


L'utente può anche cancellare il proprio Account Utente direttamente nell'app, dalla sezione "Il Mio Profilo", in qualsiasi momento e senza dover giustificare la propria decisione. PFDC può interrompere l'utilizzo dell'App da parte di un Utente a condizione di rispettare il preavviso di un (1) mese.


PFDC si riserva inoltre il diritto di chiudere l'Account Utente, ipso iure, in caso di un obbligo imposto per decisione giudiziaria , di eventi di forza maggiore, di violazioni delle presenti CGU, oppure in caso di sospetta frode.


PFDC si riserva il diritto di chiedere il risarcimento dei danni subiti a causa di tali inadempienze.


La chiusura dell'Account Utente comporta la revoca delle licenze a esso concesse; l’Utente dovrà cessare ogni utilizzo dell'App. A tal proposito, l’Utente non avrà diritto ad alcun indennizzo.

L’azienda può essere tenuta a divulgare determinate informazioni personali qualora ciò sia necessario ai fini dell'identificazione, della cattura o del perseguimento di qualsiasi individuo che possa causare danni o pregiudizi (intenzionalmente o meno) ai diritti o alla proprietà dell'App, ad altri utenti dell'App, nonché a qualsiasi altro soggetto che possa essere penalizzato da tali attività.


ARTICOLO 5. CONDIZIONI DI UTILIZZO DELL'APP


L'Utente riconosce che le condizioni del contratto con il proprio operatore di telefonia mobile continueranno ad essere in vigore durante l'utilizzo dell'App. L'Utente sosterrà personalmente tutti gli addebiti eventualmente applicati dall'operatore di telefonia mobile in relazione all'accesso ai servizi di connessione internet, wifi, wap e/o 3G, oltre che all'utilizzo dell'App.


L'Utente, durante tale utilizzo, si astiene dall'impedire, ostacolare, interrompere o perturbare il corretto funzionamento dell’App, dei server, delle reti a essa connesse e/o dal modificare, adattare, hackerare la medesima e/o dal modificare un'app o un sito di terze parti, in modo da generare confusione riguardo a un potenziale collegamento con l’App.

L'Utente è consapevole dei vincoli e dei limiti delle reti Internet e di telecomunicazione e si impegna di conseguenza a:

• proteggere il proprio Dispositivo da qualsiasi forma di virus, tentativo di intrusione, accesso e/o utilizzo non autorizzato da parte di terzi;

• garantire le condizioni per l'installazione, l'esercizio e la manutenzione del proprio Dispositivo necessarie al corretto funzionamento dell’App.


ARTICOLO 6. UTILIZZO DEI CONSIGLI DISPENSATI NELL’APP


All’interno dell’App gli utenti possono consultare Informazioni messe a loro disposizione. Tale messa a disposizione non comporta il trasferimento di alcun diritto di proprietà afferente alle Informazioni stesse. Agli Utenti è concessa solo una licenza di consultazione e di utilizzo di tali Informazioni, in modo non esclusivo e per uso privato. A tale scopo, agli Utenti è vietato copiare o riprodurre in tutto o in parte le suddette Informazioni con qualunque mezzo e su qualunque supporto, esistente o futuro, tradurre le stesse in qualunque altro linguaggio o lingua, oppure adattarle.


PFDC non può essere ritenuta responsabile delle conseguenze, dirette o indirette, e/o di eventuali danni che potrebbero verificarsi a causa di Informazioni difettose o hackerate. Inoltre, PFDC non si assume l'obbligo di un risultato ma di mezzi per quanto riguarda le Informazioni e i consigli forniti agli Utenti.


Infine, PFDC non fornisce alcuna garanzia esplicita o implicita e non si assume alcuna responsabilità in relazione all'uso di tali Informazioni o consigli. Questi dati sono forniti esclusivamente a titolo indicativo. Per ulteriori informazioni e/o domande, contattare contact.avene@pierre-fabre.com.







ARTICOLO 7. PROPRIETÀ INTELLETTUALE


Salvo disposizione contraria contenuta nelle presenti clausole, tutti gli elementi che figurano sull’App e l’App stessa (compresi in particolare testi, dati, database, grafici, loghi, marchi, denominazioni, animazioni, immagini, video, suoni, software e ogni altro elemento) (di seguito gli "Elementi") appartengono in via esclusiva a PFDC e/o alle terze parti che hanno a essa concesso una licenza, e sottostanno alla legislazione francese e internazionale sul diritto d’autore e, più in generale, sulla proprietà intellettuale.

Tali Elementi sono protetti dai diritti d’autore, copyright, marchi, brevetti, diritti sui database, segreti di fabbrica e/o qualsiasi altro diritto di proprietà intellettuale.

Tutti i diritti di riproduzione, di rappresentazione e di comunicazione pubblica sono riservati, comprese le rappresentazioni visive, fotografiche, iconografiche o di altro tipo. La riproduzione totale o parziale dell’App su qualsiasi supporto elettronico è formalmente vietata senza l'esplicita autorizzazione del direttore della pubblicazione.

I marchi e i loghi utilizzati sull’App sono stati depositati e la loro riproduzione costituisce una contraffazione. Tutti i diritti di utilizzo sono riservati. Ai sensi dell’articolo L.122-4 del Codice della proprietà intellettuale, qualsiasi rappresentazione o riproduzione integrale o parziale non espressamente autorizzata e con qualsiasi mezzo è illecita e costituisce una contraffazione sanzionata dagli articoli L. 335-2 e seguenti del Codice della proprietà intellettuale.

PFDC concede all’Utente una licenza gratuita non esclusiva, non trasferibile, personale e limitata all’uso privato, per l'accesso, l'utilizzo e la visualizzazione dell’App e dei suoi Elementi. Tale diritto è concesso per un uso esclusivamente personale, privato e non commerciale, e a condizione di conservare tutte le indicazioni relative ai diritti di riproduzione e di proprietà intellettuale ad esso correlate. In tale contesto, all’Utente è vietato copiare e/o riprodurre in tutto o in parte gli Elementi con qualsiasi mezzo e su qualsiasi supporto, esistente o futuro, tradurre gli stessi in qualsiasi altro linguaggio o altra lingua, nonché adattarli.

Si vieta formalmente qualunque altro uso degli Elementi in quanto ciò costituirebbe una violazione delle disposizioni del Codice della proprietà intellettuale.



ARTICOLO 8. HYPERLINK


L'Utente è informato che PFDC può fornire link a siti internet e/o app esterne appartenenti o meno al Gruppo Pierre Fabre. Tali siti internet e/o app sono indipendenti dall’App.

PFDC non edita né controlla fonti e contenuti di tali siti internet e/o le app, oppure i loro link ad altri siti internet e/o app.

I link a tali siti internet e/o app non costituiscono in alcun modo approvazione, convalida o adesione di PFDC al contenuto degli stessi e, a maggior ragione, all’uso che ne potrebbe essere fatto.

Di conseguenza, PFDC non può essere ritenuta responsabile del contenuto, dei prodotti, dei servizi, della pubblicità, dei cookie o di altri elementi di tali siti internet e/o app, nonché di eventuali danni o perdite, accertati o presunti, conseguenti o connessi all’uso di tali informazioni, servizi o dati disponibili su detti siti internet e/o app.

La creazione di hyperlink nell’App può essere effettuata soltanto previa autorizzazione per iscritto di PFDC. Tutte le richieste di autorizzazione devono essere inviate a: contact.avene@pierre-fabre.com.




ARTICOLO 9. GARANZIE


PFDC garantisce che il contenuto dell'App è conforme alle attuali disposizioni di legge francesi e agli standard industriali applicabili alle web app.

PFDC garantisce il pacifico godimento dell’App agli Utenti, garantendo in particolare che la stessa non violi alcun diritto di proprietà intellettuale detenuto da terzi e che sia originale.


PFDC non garantisce l'accuratezza o la completezza delle Informazioni contenute nell’App. PFDC apporterà le relative correzioni. Le Informazioni diffuse possono, d'altra parte, essere state aggiornate tra il momento in cui gli Utenti le hanno visualizzate e quello in cui gli stessi ne prendono conoscenza. PFDC non garantisce pertanto in alcun modo che tali Informazioni siano accurate, complete e aggiornate.


ARTICOLO 10. RESPONSABILITÀ


L'utilizzo dell'App è di esclusiva responsabilità dell'Utente. PFDC non può essere ritenuta responsabile di eventuali risultati ottenuti in seguito all’utilizzo dell’App. In particolare, l'Utente è stato informato che l'App non intende sostituire la consulenza medica e non prevarica il rapporto tra il professionista della sanità e il paziente/Utente.


Gli Utenti si impegnano a non introdurre volontariamente o involontariamente virus, bug o file di qualunque natura che possano perturbare il funzionamento dell’App, assumendosene, in tal caso, la piena responsabilità. Nello spirito del rispetto di tutti, PFDC potrà perseguire gli Utenti irriguardosi.


L’Utente dichiara e garantisce di conoscere perfettamente le caratteristiche e i vincoli di Internet, in particolare il fatto che le trasmissioni di dati e di informazioni sul Web beneficiano soltanto di un’affidabilità tecnica relativa, poiché queste circolano su reti eterogenee con caratteristiche e capacità tecniche diverse che perturbano l’accesso o lo rendono impossibile in determinati periodi.


PFDC non può essere ritenuta responsabile di eventuali danni derivanti dalla connessione all’App o dall’uso che l’Utente fa della stessa.


PFDC opera per mantenere accessibile l’App 7 giorni su 7 e 24 ore su 24, ma non è obbligata a tale risultato. Essa può quindi interromperne l’accesso, in particolare per motivi di manutenzione e di aggiornamento. PFDC si riserva inoltre il diritto, in qualsiasi momento e senza preavviso, di modificare, sospendere o addirittura interrompere la distribuzione di tutta L’App o di parte di essa. PFDC non può essere in alcun caso ritenuta responsabile della totalità di tali interruzioni e delle conseguenze che ne possono derivare per l’Utente o per qualsiasi terzo.


Anche se PFDC ha adottato le misure necessarie per garantire l'affidabilità delle Informazioni e dei servizi contenuti nell'App, non può essere ritenuta responsabile per eventuali errori, omissioni, virus o risultati che possono essere ottenuti attraverso un uso improprio della stessa. PFDC è, infatti, vincolata da un semplice obbligo di mezzi.


Nessuno dei dirigenti o dipendenti di PFDC può essere ritenuto responsabile:

- di eventuali danni derivanti da una connessione, un accesso o un utilizzo dell’App;

- di danni derivanti, direttamente o indirettamente, dalla consultazione dell’App o dall’uso delle Informazioni disponibili sull’App stessa;

- di danni diretti o indiretti derivanti dall’uso dell’App, in particolare di qualsiasi perdita operativa, finanziaria o commerciale, oppure perdita di software o di dati contenuti in qualunque sistema di informazione, anche se PFDC dovesse essere a conoscenza dell’eventualità di tali danni.

In nessun caso PFDC può essere ritenuta responsabile di un’eventuale perdita delle Informazioni o di un eventuale deterioramento delle stesse. Qualunque Informazione o consiglio fornito dall’App non può essere interpretato come una garanzia.


ARTICOLO 11. DATI PERSONALI


L'accesso e l'utilizzo dell'App comportano la raccolta di dati personali (cognome, nome, indirizzo e-mail), che l'Utente accetta. Tali dati personali saranno conservati per il tempo necessario all'utilizzo dell'App. Per ulteriori informazioni sul trattamento dei dati personali e sui propri diritti, consultare l'Informativa sulla Privacy.


ARTICOLO 12. LEGGE APPLICABILE E RISOLUZIONE DELLE CONTROVERSIE


Le CGU sono assoggettate al diritto francese. Qualsiasi controversia che dovesse insorgere in relazione alle presenti CGU sarà sottoposta a mediazione preliminarmente a qualunque azione giudiziaria o arbitrale. In caso di insuccesso della mediazione, la controversia sarà sottoposta al giudice competente nel distretto della Corte d’Appello di Parigi. In caso di traduzione delle CGU, sarà valida e applicabile soltanto la versione francese.


ARTICOLO 13. MODIFICA DELLE CGU


Gli Utenti dichiarano e riconoscono di aver letto le CGU e l’utilizzo dell’App costituisce da parte degli stessi formale e incondizionata accettazione di tutte le CGU. Le CGU possono essere modificate in qualsiasi momento da PFDC. Tali modifiche saranno comunicate all’Utente. L’utilizzo dell’App dopo la comunicazione di una modifica varrà come accettazione delle CGU. Le CGU applicabili saranno pertanto quelle in vigore sull’App alla data in cui l’Utente la utilizza. In caso di disaccordo sulle modifiche delle CGU, l’Utente si impegna a non accedere all’App e a rimuoverla dal Dispositivo.


Versione 4 27/08/2024
`

export default text;